import { Row } from '@tanstack/react-table';
import { Attributes, TableColumn } from '../models';

const REGEX_PLACEHOLDER = /\{([^\}]+)\}/g;

export const getReplacedTemplateLiteralByAttributesUrlEncoded = async (
  templateLiteral: string,
  row: Row<TableColumn>,
  attributes?: Attributes,
): Promise<string> => {
  const newLiteral = templateLiteral;
  const attributeValues = new Map<string, string>();

  // Iterate through the attributes to fetch and process values from the table row
  for (let placeholder in attributes) {
    const attributeValue = row.getValue(attributes[placeholder].attribute);
    if (attributeValue !== undefined && attributeValue !== null) {
      // Properly encode the attribute value before storing it
      const encodedValue = encodeURIComponent(attributeValue.toString());
      attributeValues.set(placeholder, encodedValue);
    }
  }

  // Replace placeholders in the template literal with corresponding values
  return newLiteral.replace(REGEX_PLACEHOLDER, (_, placeholder) =>
    attributeValues.has(placeholder) ? attributeValues.get(placeholder)! : '',
  );
};
